import BaseRepository from "core/repository/base.repository";
import { InvoicesBillingService } from "core/service";
import { InvoicesBilling } from "core/entity";

class InvoicesBillingRepository extends BaseRepository {
  syncable = false;

  getEntityIdentifier() {
    return "invoices-billing";
  }

  resourceName() {
    return "faturas";
  }

  getServiceProvider() {
    return InvoicesBillingService;
  }

  async modelToEntity({ id, due_date, items, secure_url, status }) {
    return new InvoicesBilling({ id, due_date, items, secure_url, status });
  }
}

export default new InvoicesBillingRepository();



// WEBPACK FOOTER //
// ./src/core/repository/invoices-billing.repository.js